import { buildCollection, buildProperty } from "@firecms/core";
import { feedbackSourceEnumValues } from "./shared/enums";

export type Feedback = {
    id?: string;
    userId?: string;
    deviceId?: string;
    title?: string;
    content?: string;
    appVersion?: string;
    source?: keyof typeof feedbackSourceEnumValues;
    createdAt?: Date;
};

/**
 * feedbacks — uygulama geri bildirimleri. Salt okunur.
 */
export const feedbacksCollection = buildCollection<Feedback>({
    id: "feedbacks",
    name: "Geri bildirimler",
    singularName: "Geri bildirim",
    path: "feedbacks",
    group: "Kullanıcılar",
    icon: "feedback",
    description: "Kullanıcı geri bildirimleri (salt okunur)",
    titleProperty: "title",
    initialSort: ["createdAt", "desc"],
    permissions: {
        read: true,
        create: false,
        edit: false,
        delete: false,
    },
    properties: {
        title: buildProperty({
            name: "Başlık",
            dataType: "string",
            readOnly: true,
        }),
        content: buildProperty({
            name: "İçerik",
            dataType: "string",
            multiline: true,
            readOnly: true,
        }),
        userId: buildProperty({
            name: "Kullanıcı ID",
            dataType: "string",
            readOnly: true,
        }),
        deviceId: buildProperty({
            name: "Cihaz ID",
            dataType: "string",
            readOnly: true,
        }),
        source: buildProperty({
            name: "Kaynak",
            dataType: "string",
            enumValues: feedbackSourceEnumValues,
            readOnly: true,
        }),
        appVersion: buildProperty({
            name: "Uygulama sürümü",
            dataType: "string",
            readOnly: true,
        }),
        createdAt: buildProperty({
            name: "Oluşturulma",
            dataType: "date",
            mode: "date_time",
            readOnly: true,
        }),
        id: buildProperty({
            name: "Kayıt ID",
            dataType: "string",
            readOnly: true,
        }),
    },
});
